import { CookieSetOptions } from 'universal-cookie'
import { isEmpty } from 'lodash'

const ONE_DAY: number = 24 * 3600

export const cookieOptions = (): CookieSetOptions => {
  // , domain: process.env.SESSION_COOKIE_HOSTNAME || ''
  const cookie: CookieSetOptions = {
    path: '/',
    maxAge: ONE_DAY,
    secure: !['localhost', '127.0.0.1'].includes(window.location.hostname),
    sameSite: 'lax'
  }
  if (!isEmpty(process.env.SESSION_COOKIE_HOSTNAME)) {
    cookie.domain = process.env.SESSION_COOKIE_HOSTNAME
  }
  return cookie
}

// If token is string 'null', sets it to undefined instead
export const parseSessionToken = (token?: string): string | undefined => {
  return token !== 'null' ? token : undefined
}

export const removeBearerFromToken = (token?: string): string | undefined => {
  if (token === undefined) return undefined

  if (token?.includes('Bearer')) {
    return token.split(' ')[1]
  }
  return token
}
